<template>
    <div>
        <div class="row tl-bookmark-block" v-for="link in links" v-bind:key="link.id">
            <div class="col-md-4">
                <img ref="previewImage"
                     :src="link.previewImageUrl || '/broken_image_placeholder_small2.png'"
                     class="previewImage"
                     @click="showFullSizePreview($event)"
                     alt="Preview"
                     onerror="if (this.src != '/broken_image_placeholder_small2.png') this.src = '/broken_image_placeholder_small2.png'"/>
            </div>
            <div class="col-md-8">
                <div class="bookmark-card mb-2">
                    <div class="bookmark-card-header">
                        <a class="bi bi-person-circle tl-link tl-user-profile-icon"
                           :href="'/bookmarks/' + link.owner"><span class="tl-link-small">&nbsp;{{link.owner}}</span>
                        </a>
                        <span class="dot-separator">&nbsp;·&nbsp;</span>
                        <span class="tl-link-small">added {{ formatDate(link.addedOn) }}
                        </span>
                        <span class="dot-separator">&nbsp;·&nbsp;</span>
                        <i v-if="link.visibility==='PRIVATE'"
                           class="bi bi-shield-shaded tl-icon-visibility-private pr-2"
                           data-toggle="tooltip"
                           data-placement="right"
                           title="this link is private, and can only be seen by you"
                        ></i>
                        <i v-if="link.visibility==='PUBLIC'"
                           class="bi bi-globe-americas tl-icon-visibility-public pr-2"
                           data-toggle="tooltip"
                           data-placement="right"
                           title="this link is public, and can be seen by anyone"
                        ></i>
                    </div>

                    <div class="text-break">
                        <a :href="link.url" class="tl-link" target="_blank">
                            <span class="tl-link-title">{{ link.description }}</span>
                        </a>
                    </div>

                    <div class="overflow-hidden text-truncate">
                        <a :href="link.url" class="tl-link" target="_blank">
                            <span :title="link.url" class="tl-link-small">{{link.url}}</span>
                        </a>
                    </div>
                <div class="bookmark-card-tags">
                    <span class="mr-1 tl-link-small">Tagged</span>
                    <span class="badge tl-inactive-badge" v-if="link.tags.length == 0">untagged</span>
                    <a v-for="tag in link.tags" v-bind:key="tag"
                       :href="'/bookmarks/'+link.owner+'/tag/'+tag"
                       class="badge tl-tag tl-badge icon-grow">{{ tag }}
                    </a>
                </div>
                </div>
            </div>

        <div class="col-12 link-action-bar mt-2">
            <a :href="link.url"
               class="link-action-button btn"
               target="_blank"
               title="open bookmark in new tab"><span class="bi bi-box-arrow-up-right"></span>&nbsp;open</a>

            <a class="link-action-button btn"
                   v-if="canEditLinks"
                @click="selectLinkForAction(link)"
                data-toggle="modal"
                data-target="#shareBookmarkModal">
                <span class="bi bi-share"/>&nbsp;share</a>

            <a class="link-action-button btn"
               v-if="canEditLinks"
               data-toggle="modal"
               data-target="#editModal"
                @click="selectLinkForAction(link)">
            <span class="bi bi-pencil"/>&nbsp;modify</a>

            <a class="link-action-button btn"
               v-if="canEditLinks"
               data-toggle="modal"
               data-target="#deleteModal"
                @click="selectLinkForAction(link)">
                <span class="bi bi-trash text-danger "/>
                <span class="text-danger">&nbsp;delete</span>
            </a>
            </div>
        </div>

        <div class="modal fade" id="deleteModal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Confirmation</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <error-panel showInPopup="true" />
                        You are about to delete your saved bookmark:
                        <div><b class="">{{selectedLink?.description}}</b></div>
                        Are you sure?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Nope</button>
                        <button type="button" class="btn btn-danger" @click="deleteLink(selectedLink)">I am sure</button>
                    </div>
                </div>
            </div>
        </div>

        <div ref="editModal" class="modal fade" id="editModal" tabindex="-1">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Modify bookmark</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <error-panel showInPopup="true" />
                        <link-save-form
                                :key="'lsm-'+JSON.stringify(selectedLink)"
                                :defaultUrl="this.selectedLink?.url"
                                :defaultTitle="this.selectedLink?.description"
                                :defaultTags="this.selectedLink?.tags"
                                :defaultVisibility="this.selectedLink?.visibility"
                                :defaultSuggestedTags="[]"
                                :defaultPreviewImageUrl="this.selectedLink?.previewImageUrl"
                                loadMetadata="off"
                                :saveInProgress="updateRequestInProgress"
                                @saved="updateLink" />

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" ref="shareBookmarkModal"  id="shareBookmarkModal" tabindex="-1" v-bind:key="'share-'+shareUrl">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title"><span class="bi bi-share tl-link-copy-url-icon mr-3"></span>Share bookmark</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">

                <error-panel showInPopup="true" />

                  <div v-if="this.selectedLink?.visibility==='PUBLIC'">
                    <p>This bookmark is shared on the following url:</p>
                      <div class="text-truncate">
                        <a id="shareUrl" class="mb-3" target="_blank" :href="shareUrl" style="text-overflow:ellipsis">
                            <span>{{ shareUrl  }}</span>
                        </a>
                      </div>
                  </div>
                  <div v-if="this.selectedLink?.visibility==='PRIVATE'">
                      <p>Your bookmark needs to be public before it can be shared.</p>
                      <spinner-button
                                :spinning="visibilityRequestInProgress"
                                class="btn-primary"
                                @click="setLinkToPublic(selectedLink)">
                      Make it public and share...
                  </spinner-button>
              </div>
              </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <a v-if="this.selectedLink?.visibility==='PUBLIC'" id="copy-share-url" class="btn btn-success" data-clipboard-target="#shareUrl">
                        <span id="share-url-icon" class="bi bi-files"><span class="mr-2"></span>Copy link</span>
                    </a>
                </div>
          </div>
        </div>
      </div>
        <div
            v-if="fullScreenImageUrl !== null"
            @click.self="closeFullScreenImage"
            class="fullscreen-image-overlay">
                <span
                    @click="closeFullScreenImage"
                    class="close-btn" >&times;
                </span>
                <img
                    :src="fullScreenImageUrl"
                    class="fullscreen-image img-fluid rounded"
                />
        </div>
    </div>
</template>

<script>
import LinkSaveForm from "@/components/LinkSaveForm";
import ErrorPanel from "@/components/ErrorPanel";
import SpinnerButton from "@/components/SpinnerButton";
import BackendClient from "@/rest/backend-client";
import ClipboardJS from "clipboard";

export default {
    name: "LinkList",
    components: {
        ErrorPanel, LinkSaveForm, SpinnerButton
    },
    data() {
        return {
            selectedLink: null,
            backendClient: new BackendClient(),
            visibilityRequestInProgress: false,
            updateRequestInProgress: false,
            fullScreenImageUrl: null
        }
    },
    props: ['links', 'owner'],
    mounted () {
        this.initializeBootstrapComponents();
        this.initializeClipboardJS();
    },
    computed: {
        canEditLinks: function() {
          return this.$store.state.userLoggedIn
            && this.owner === this.$store.state.loggedInUserName;
        },
        hasLinks() {
          return this.links && this.links.length > 0;
        },
        shareUrl() {
            if (!this.selectedLink) {
                return null;
            }
            return `${process.env.VUE_APP_FRONTEND_URL}/share/${this.selectedLink.owner}/${this.selectedLink.id}`
        }
    },
    methods: {
        selectLinkForAction(link) {
          this.selectedLink = Object.assign({}, link);
        },
        updateLink(updatedEvent){
          this.updateRequestInProgress = true;
          this.backendClient.updateLink(this.selectedLink.id, updatedEvent.url,
            updatedEvent.title, updatedEvent.tags, updatedEvent.visibility).then(() => {
            // eslint-disable-next-line
            $(this.$refs.editModal).modal('hide');
            const link = this.links.find(link => link.id === this.selectedLink.id);
            if (link) {
              link.url = updatedEvent.url;
              link.description = updatedEvent.title;
              link.tags = updatedEvent.tags;
              link.visibility = updatedEvent.visibility;
            }
          }).finally(() => { this.updateRequestInProgress=false });
        },
        deleteLink(link) {
          this.backendClient.deleteLink(link.id).then(() => {
            // eslint-disable-next-line
            $('#deleteModal').modal('hide');
            const index = this.links.findIndex(_link => _link.id === link.id);

            // TODO: do not mutate, emit event
            // eslint-disable-next-line
            this.links.splice(index, 1);
          });
        },
        setLinkToPublic(link) {
            this.visibilityRequestInProgress = true;
            this.backendClient.setLinkVisibility(link.id, 'PUBLIC').then(() => {
                const existingLink = this.links.find(_link => _link.id === link.id);

                if (existingLink) {
                    existingLink.visibility = 'PUBLIC';
                }
                link.visibility = 'PUBLIC';
                this.selectedLink.visibility = 'PUBLIC';
            }).finally(() => {
                this.visibilityRequestInProgress = false;
            });
        },
        initializeBootstrapComponents() {
          // eslint-disable-next-line
          $(function () {
            // eslint-disable-next-line
            $('[data-toggle="tooltip"]').tooltip()
          })
        },
        initializeClipboardJS() {
          const clipboard = new ClipboardJS('#copy-share-url');
          clipboard.on('success', function() {
            const shareUrlIcon = document.querySelector("#share-url-icon");
            shareUrlIcon.className="bi bi-check-circle";
          });
        },
        formatDate(date) {
          return this.$options.filters.date(date);
        },
        showFullSizePreview(event){
            this.fullScreenImageUrl = event.srcElement.getAttribute('src');
        },
        closeFullScreenImage() {
            this.fullScreenImageUrl = null;
        }
  }
}
</script>

<style>
    .tl-link-copy-url-icon {
        color: #aaa;
        padding-left: 0.1em;
    }
    .dropdown-item {
        cursor: pointer;
    }

    .bookmark-card {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: stretch;
        align-content: space-between;

        height: 100%;
    }

    .bookmark-card-header {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;

        font-size: 0.8em;
    }

    .previewImage {
        width: 100%;
        max-height: 120px;
        object-fit: cover;
        padding-bottom: 3px;
        cursor: pointer;
    }

    .dot-separator {
        color:#aaa;
    }

    .link-action-button {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        align-content: space-between;

        color:#686868;
        font-size: 0.9em;
        margin: 0px;
        width: 100%;
        border-radius: 1px
    }

    .link-action-button:hover {
        background-color: #ffc107;
    }

    .link-action-bar {
        background-color: #f7f7f7;
        border-radius: 0px 0px 5px 5px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: stretch;
        align-content: stretch;
        border-top: 1px dotted lightgray;
        padding-left: 0px;
        padding-right: 0px;
        height:45px;
    }
</style>